// extracted by mini-css-extract-plugin
export default {"container":"thankyou_container__wjmeX","titulo":"thankyou_titulo__j9JQO","subtitulo":"thankyou_subtitulo__IhTKC"};